import React from "react";
import {
  CheckboxContainer,
  CheckboxLabel,
  HeaderSection,
  MainContainer,
} from "../index.styled";
import { ReactComponent as AffiliationsFilter } from "../../../Assets/Icons/AffiliationsFilter.svg";
import styled from "styled-components";
import { viewSizeCalculator } from "../../../utils";

const Affiliations = ({ data, reference }) => {
  const fields = data.fields;
  return (
    <MainContainer ref={reference}>
      <HeaderSection>
        <AffiliationsFilter />
        {data.category}
      </HeaderSection>
      <ContentWrapper>
        <RowContainer width={"20%"}>
          {fields.map((ele, ind) => (
            <CheckboxContainer>
              <input
                style={{
                  cursor: "pointer",
                  accentColor: "#F96250",
                  width: viewSizeCalculator(1.063),
                  height: viewSizeCalculator(1.063),
                }}
                type="checkbox"
                id={ele.label}
              />
              <CheckboxLabel htmlFor={ele.label}>{ele.label}</CheckboxLabel>
            </CheckboxContainer>
          ))}
        </RowContainer>
      </ContentWrapper>
    </MainContainer>
  );
};

export default Affiliations;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const RowContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: ${({ wrap }) => (wrap ? "wrap" : "no-wrap")};
  gap: 20px;

  width: ${({ width }) => width || "70%"};
`;
